import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

import PerButton from '../Button'
import PerFlexRow from '../FlexRow'
import { ForecastModalEmployeeFiltersForm, ForecastModalEmployeeFiltersToolbar } from '.'

export const ForecastModalEmployeeFilters: FC<unknown> = () => {
  const { t } = useTranslation()

  const [showFilterForm, toggleFilterForm] = useState<boolean>(false)

  return (
    <>
      <PerFlexRow mt="m" mb="xxxs">
        <PerButton
          text={t('pyramidsView.forecastModal.buttons.viewFilters')}
          color="primary"
          before={!!showFilterForm ? 'remove_stroke' : 'add_stroke'}
          type="button"
          onClick={() => toggleFilterForm(!showFilterForm)}
        />
        <ForecastModalEmployeeFiltersToolbar />
      </PerFlexRow>
      {!!showFilterForm && (
        <PerFlexRow mt="s">
          <ForecastModalEmployeeFiltersForm toggleFilterForm={toggleFilterForm} />
        </PerFlexRow>
      )}
    </>
  )
}
